import React from 'react';

const LOGO_SRC = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/hj7l1f73_unnamed.png';

// Official Victory Plumbing medallion logo.
export default function Logo({ size = 56 }) {
  return (
    <span className="logo-mark" aria-hidden="true">
      <img src={LOGO_SRC} width={size} height={size} alt="" loading="eager" />
    </span>
  );
}
